export default function Header() {
    return (
        <section className="relative block h-[500px]">
            <div className="bg-profile-background bg-cover bg-center absolute top-0 w-full h-full" />
        </section>
    );
}
